import { useEffect, useRef, useState } from "react";
import { Download, Loader2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { arquivoUrl } from "@/fiscal";

// Cupom fiscal (DANFE NFC-e, com QR Code e chave de acesso) mostrado dentro do sistema.
// Antes ele abria numa janela nova, que o navegador bloqueia depois da espera da SEFAZ.
export function DanfeDialog({ nota, onClose, closeLabel = "Fechar" }) {
  const [url, setUrl] = useState("");
  const [erro, setErro] = useState("");
  const frame = useRef(null);
  useEffect(() => {
    if (!nota?.id) return undefined;
    let ativo = true;
    let criada = "";
    setUrl("");
    setErro("");
    arquivoUrl(`/notas/${nota.id}/pdf`)
      .then((u) => { criada = u; if (ativo) setUrl(u); else URL.revokeObjectURL(u); })
      .catch((e) => ativo && setErro(e.message));
    return () => { ativo = false; if (criada) URL.revokeObjectURL(criada); };
  }, [nota?.id]);
  const imprimir = () => {
    try {
      frame.current?.contentWindow?.focus();
      frame.current?.contentWindow?.print();
    } catch (_) {
      window.open(url, "_blank");
    }
  };
  return (
    <Dialog open={!!nota} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md max-h-[94dvh] flex flex-col gap-3 p-5" data-testid="danfe-modal">
        <DialogHeader>
          <DialogTitle>Cupom fiscal{nota?.numero ? ` · NFC-e nº ${nota.numero}` : ""}</DialogTitle>
          <DialogDescription>NFC-e autorizada pela SEFAZ. Imprima e entregue ao cliente.</DialogDescription>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-hidden rounded-lg border bg-white">
          {!url && !erro && <p className="flex h-64 items-center justify-center text-sm text-slate-500"><Loader2 className="mr-2 h-4 w-4 animate-spin" />Carregando o cupom…</p>}
          {erro && <p className="p-4 text-sm text-red-600" data-testid="danfe-error">{erro}</p>}
          {url && <iframe ref={frame} src={url} title="DANFE NFC-e" className="h-[60dvh] w-full" data-testid="danfe-frame" />}
        </div>
        <DialogFooter className="shrink-0 gap-2 sm:justify-between">
          <div className="flex gap-2">
            <Button variant="outline" disabled={!url} onClick={imprimir} data-testid="danfe-print-btn"><Printer className="mr-2 h-4 w-4" />Imprimir</Button>
            <Button asChild variant="outline" disabled={!url}>
              <a href={url || undefined} download={`nfce-${nota?.numero || "cupom"}.pdf`} data-testid="danfe-download-btn"><Download className="mr-2 h-4 w-4" />PDF</a>
            </Button>
          </div>
          <Button onClick={onClose} data-testid="danfe-close-btn">{closeLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
